/* istanbul ignore file */

import { ChangeEvent, useState } from 'react';

interface UseTextAreaFormFieldProps {
  required: boolean;
}

export const useTextAreaFormField = ({ required }: UseTextAreaFormFieldProps) => {
  const [field, setField] = useState('');
  const [hasError, setHasError] = useState(false);

  const resetInitialState = () => {
    setField('');
    setHasError(false);
  };

  const onChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = e.target.value;

    setField(newValue);
  };

  const validate = () => {
    if (required) {
      const isValid = Boolean(field.length);
      setHasError(!isValid);

      return isValid;
    }

    return true;
  };

  return [field, onChange, hasError, validate, resetInitialState] as const;
};
